import React from "react";
// ANT DESIGN COMPONENTS
import { Dropdown, Menu, Space } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faTrash, faPenToSquare, faBan, faFileExport, faKey } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
	updateOpenModalDeleteServer,
	updateServer,
	updateOpenModalExportServer,
	updateFormAction,
} from "../../../redux/servers/serverSlice";
import { updateOpenModalTotpToken } from "../../../redux/authentication/authenticationSlice";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
// COMPONENTS
import TableActionsMenuItem from "../../components/table/TableActionsMenuItem";
// INTERFACES
import { RootState } from "../../../app/store";
import { ServerInterface } from "../../../interfaces/Server.interface";

function ServersTableActions({ selectedItem }: { selectedItem: ServerInterface }) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const handleOpenModalTotpToken = () => {
		dispatch(updateServer(selectedItem));
		dispatch(updateOpenModalTotpToken(true));
	};

	const handleOpenModalEdit = () => {
		dispatch(updateServer(selectedItem));
		dispatch(updateFormAction("edit"));
	};

	const handleOpenModalDelete = () => {
		dispatch(updateServer(selectedItem));
		dispatch(updateOpenModalDeleteServer(true));
	};

	const handleOpenModalExport = () => {
		dispatch(updateServer(selectedItem));
		dispatch(updateOpenModalExportServer(true));
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// ROW ACTIONS ************************************ */
	const manageActions = () => {
		const BLANK = {
			label: (
				<div className='generalStyles__tableActionBox'>
					<span>
						<FontAwesomeIcon className='generalStyles__error generalStyles__mrFix' icon={faBan} />
						{t("general.noActions")}
					</span>
				</div>
			),
			key: "0",
		};

		const SECRET_CLIENT = validatePermission("servers-oauth-create", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faKey}
							text={t("edgeManagement.servers.secretClient")}
							onClick={handleOpenModalTotpToken}
						/>
					),
					key: "2",
			  }
			: null;

		const EDIT = validatePermission("servers-update", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faPenToSquare}
							text={t("organizationManagement.edit")}
							onClick={handleOpenModalEdit}
						/>
					),
					key: "3",
			  }
			: null;

		const DELETE = validatePermission("servers-delete", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faTrash}
							text={t("organizationManagement.delete")}
							onClick={handleOpenModalDelete}
						/>
					),
					key: "4",
			  }
			: null;

		const EXPORTOPTION = validatePermission("servers-export", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faFileExport}
							text={t("organizationManagement.exportDescription")}
							onClick={handleOpenModalExport}
						/>
					),
					key: "5",
			  }
			: null;

		// RETURN OBJECT WITH VALID ACTIONS
		if (EDIT || DELETE || SECRET_CLIENT || EXPORTOPTION) {
			return [EDIT, SECRET_CLIENT, EXPORTOPTION, DELETE];
		}
		return [BLANK];
	};

	const menu = <Menu items={manageActions()} />;

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<Dropdown overlay={menu} trigger={["click"]}>
				<Space className='generalStyles__hoverCursor'>
					<FontAwesomeIcon icon={faEllipsis} />
				</Space>
			</Dropdown>
		</div>
	);
}

export default ServersTableActions;
